import "./demoMotion.css";
import "./demoThemes.css";
import "./demoComplete.css";
import { DemoBrowser, DemoFullFooter, DemoContactBlock } from "./DemoFullParts";

const CLASSES = [
  { name: "React 실무 A반", students: 18, progress: 78 },
  { name: "Python 기초 B반", students: 22, progress: 62 },
  { name: "웹 퍼블 C반", students: 8, progress: 91 },
];

export default function EdtechDemo({ embed = false }) {
  return (
    <div
      className={`demo-root demo-study${embed ? " demo-root--embed" : ""}`}
      data-testid="portfolio-demo-edtech"
      style={{
        "--accent": "#22a06b",
        "--bg": "#f4f7f5",
        "--muted": "#5c7268",
        "--border": "#dce8e0",
        "--card": "#ffffff",
        "--section-alt": "#eaf2ec",
      }}
    >
      <header className="demo-full__nav" style={{ background: "#fff", boxShadow: "0 2px 12px rgba(26,46,36,.06)" }}>
        <div className="demo-study__logo">
          <span className="demo-study__logo-icon">S</span>
          StudyBridge
        </div>
        <nav className="demo-full__nav-links" style={{ color: "#5c7268" }}>
          <span>플랫폼</span>
          <span>기능</span>
          <span>요금</span>
          <span>도입 사례</span>
        </nav>
        <span className="demo-full__nav-cta" style={{ background: "#22a06b" }}>무료 체험</span>
      </header>

      <section className="demo-full__hero" style={{ background: "linear-gradient(180deg, #eaf8f0, #f4f7f5)" }}>
        <div className="demo-full__hero-grid">
          <div>
            <span className="demo-full__eyebrow">Academy Operations Platform</span>
            <h1 style={{ color: "#1a2e24" }}>
              학원 운영,
              <br />
              하나의 플랫폼으로
            </h1>
            <p className="demo-full__hero-lead" style={{ color: "#5c7268" }}>
              강의·수강생·과제·피드백·알림을 통합 관리합니다.
              엑셀과 단톡방에 흩어진 업무를 줄이고, 운영 효율을 높입니다.
            </p>
            <div className="demo-full__hero-btns">
              <span className="demo-full__btn demo-full__btn--primary" style={{ background: "#22a06b" }}>데모 신청</span>
              <span className="demo-full__btn demo-full__btn--secondary" style={{ borderColor: "#dce8e0", color: "#1a2e24" }}>기능 소개</span>
            </div>
            <div className="demo-full__trust" style={{ color: "#5c7268" }}>
              <div><strong style={{ color: "#22a06b" }}>48명</strong>동시 관리</div>
              <div><strong style={{ color: "#22a06b" }}>94%</strong>출석률</div>
              <div><strong style={{ color: "#22a06b" }}>-35%</strong>운영 시간</div>
            </div>
          </div>
          <DemoBrowser url="app.studybridge.co.kr/dashboard" accent="#22a06b">
            <div style={{ padding: "1rem", background: "#f4f7f5" }}>
              <div style={{ padding: "1rem", borderRadius: 14, background: "linear-gradient(135deg,#166534,#22a06b)", color: "#fff", marginBottom: "0.75rem" }}>
                <strong style={{ fontSize: "0.9rem" }}>오늘의 클래스</strong>
                <p style={{ margin: "0.25rem 0 0", fontSize: "0.72rem", opacity: 0.9 }}>강의 3개 · 미제출 5건</p>
              </div>
              {CLASSES.map((c) => (
                <div key={c.name} style={{ padding: "0.75rem", marginBottom: "0.5rem", borderRadius: 12, background: "#fff", border: "1px solid #dce8e0" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.78rem", fontWeight: 700, color: "#1a2e24" }}>
                    <span>{c.name}</span>
                    <span style={{ color: "#5c7268" }}>{c.students}명</span>
                  </div>
                  <div className="demo-study__progress"><span style={{ width: `${c.progress}%` }} /></div>
                </div>
              ))}
            </div>
          </DemoBrowser>
        </div>
      </section>

      <div className="demo-full__marquee" style={{ background: "#fff" }}>
        <div className="demo-full__marquee-track" style={{ color: "#9cb0a4" }}>
          {["해커스", "이듬학원", "코딩랩", "영어전문학원", "온라인클래스", "해커스", "이듬학원"].map((n, i) => (
            <span key={`${n}-${i}`}>{n}</span>
          ))}
        </div>
      </div>

      <section className="demo-full__section">
        <div className="demo-full__wrap">
          <div className="demo-full__head">
            <h2 style={{ color: "#1a2e24" }}>학원 운영에 필요한 모든 기능</h2>
            <p style={{ color: "#5c7268" }}>반복 업무를 자동화하고, 수강생 경험을 개선합니다.</p>
          </div>
          <div className="demo-full__grid3">
            {[
              { icon: "▣", t: "강의·클래스 관리", d: "커리큘럼, 일정, 강사 배정을 한곳에서." },
              { icon: "◎", t: "수강생·출결", d: "등록, 진도, 출결 현황 실시간 확인." },
              { icon: "✎", t: "과제·피드백", d: "제출, 채점, 피드백 워크플로 통합." },
            ].map((f) => (
              <article key={f.t} className="demo-full__card" style={{ background: "#fff" }}>
                <div className="demo-full__card-icon" style={{ background: "rgba(34,160,107,.12)" }}>{f.icon}</div>
                <h3 style={{ color: "#1a2e24" }}>{f.t}</h3>
                <p style={{ color: "#5c7268" }}>{f.d}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="demo-full__section demo-full__section--alt">
        <div className="demo-full__wrap">
          <div className="demo-full__steps">
            {[
              { n: "1", t: "클래스 개설", d: "강의·일정·강사 등록" },
              { n: "2", t: "수강생 관리", d: "등록·출결·알림" },
              { n: "3", t: "과제 운영", d: "제출·피드백·마감" },
              { n: "4", t: "리포트", d: "반별 현황 요약" },
            ].map((s) => (
              <div key={s.n} className="demo-full__step">
                <div className="demo-full__step-num" style={{ background: "#22a06b" }}>{s.n}</div>
                <h4 style={{ color: "#1a2e24" }}>{s.t}</h4>
                <p style={{ color: "#5c7268" }}>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="demo-full__section">
        <div className="demo-full__wrap">
          <div className="demo-full__quotes">
            {[
              { q: "엑셀과 단톡방 안내가 줄어서 원장님 업무가 확 줄었어요.", name: "박미래", role: "원장 · 코딩 학원", init: "박" },
              { q: "수강생이 과제와 피드백을 앱에서 바로 확인해서 문의가 줄었습니다.", name: "정하늘", role: "운영팀 · 온라인 교육", init: "정" },
              { q: "출결·과제 현황을 한 화면에서 보니 강사 관리가 훨씬 수월합니다.", name: "김태호", role: "강사 · IT 학원", init: "김" },
            ].map((q) => (
              <blockquote key={q.name} className="demo-full__quote" style={{ background: "#fff" }}>
                <p style={{ color: "#5c7268" }}>"{q.q}"</p>
                <footer className="demo-full__quote-author">
                  <span className="demo-full__avatar" style={{ background: "linear-gradient(135deg,#22a06b,#4ade80)" }}>{q.init}</span>
                  <div>
                    <strong style={{ color: "#1a2e24" }}>{q.name}</strong>
                    <span style={{ color: "#5c7268" }}>{q.role}</span>
                  </div>
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </section>

      <DemoContactBlock
        title="학원 맞춤 데모 신청"
        sub="규모와 운영 방식에 맞는 플랜과 도입 일정을 안내해 드립니다."
        fields={["학원명", "담당자", "연락처", "수강생 규모 (명)", "문의 내용"]}
        btnLabel="데모 신청하기"
      />

      <DemoFullFooter
        brand="StudyBridge"
        desc="학원·온라인 교육을 위한 통합 운영 플랫폼"
        columns={[
          { title: "솔루션", links: ["학원 ERP", "온라인 클래스", "알림 연동", "학부모 앱"] },
          { title: "리소스", links: ["가이드", "요금", "보안", "FAQ"] },
          { title: "문의", links: ["hello@studybridge.co.kr", "카카오 채널", "02-9876-5432"] },
        ]}
        copy="© 2026 StudyBridge. All rights reserved."
      />
    </div>
  );
}
